import { FC } from 'react';
import { useSelector } from 'react-redux';
import { DropdownFilter, DropdownSelect, useDropdown } from 'shared/components/DropdownFilter';
import { useShowSearchMetaTooltip } from 'shared/hooks';
import { FILTER_KEY } from './constants';
import { selectStarRatingFilter } from 'shared/selectors/filters';
import { useStartRatingChangeHandler } from './hooks';

export const StarRatingContainer: FC = () => {
  const { label, value, options } = useSelector(selectStarRatingFilter);

  const onChange = useStartRatingChangeHandler();

  const dropdownState = useDropdown(FILTER_KEY);

  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  return (
    <DropdownFilter
      {...dropdownState}
      showTooltip={showTooltip}
      buttonLabel={label}
      dropdownContent={<DropdownSelect options={options} value={value} onChange={onChange} multiple />}
    />
  );
};
